import Imatge from 'components/corporatiu/Imatge';
import styles from './miramarato.module.scss';
import Enllac from 'components/corporatiu/Enllac/index.js';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';

const MiraMarato = (props) => {
    const { lang = 'ca', seccio } = props;

    const textsCA = {
        titol: 'Mira tot el que has fet possible',
        impactes: 'Impactes',
        recaptacions: 'Recaptacions',
        projectes: 'Projectes',
        conferencies: 'Sessions divulgatives',
        activitats: 'Activitats populars'
    };
    const textsES = {
        titol: 'Mira todo lo que has hecho posible',
        impactes: 'Impactos',
        recaptacions: 'Recaudaciones',
        projectes: 'Proyectos',
        conferencies: 'Sesiones divulgativas',
        activitats: 'Actividades populares'
    };
    const textsEN = {
        titol: 'See everything you made possible',
        impactes: 'Figures',
        recaptacions: 'Fund-raising',
        projectes: 'Funded projects',
        conferencies: 'Talks',
        activitats: 'Public activities'
    };

    const texts = lang === 'ca' ? textsCA : lang === 'es' ? textsES : textsEN;
    const idioma = lang === 'ca' ? '' : `${lang}/`;

    const stylesMiraMarato = clsx({
        [styles.miraMarato]: true,
        [styles.enSeccio]: !__isEmpty(seccio)
    });

    return (
        <div className={stylesMiraMarato}>
            {__isEmpty(seccio) && <h2 className={styles.titol}>{texts.titol}</h2>}
            <div className={styles.botons}>
                <Enllac
                    className={`${styles.boto} ${styles.botoImpactes} ${seccio === 'impactes' ? styles.selected : ''}`}
                    href={`/tv3/marato/${idioma}totes-maratons/mira-el-que-has-fet-possible/impactes/`}
                >
                    <Imatge
                        src='//statics.3cat.cat/recursos/marato/img/icn-impactes-htmltwig-Mira.png'
                        alt=''
                        aria-hidden='true'
                        width={124}
                        height={45}
                    />
                    <span>{texts.impactes}</span>
                </Enllac>
                <Enllac
                    className={`${styles.boto} ${seccio === 'recaptacions' ? styles.selected : ''}`}
                    href={`/tv3/marato/${idioma}totes-maratons/mira-el-que-has-fet-possible/recaptacions/`}
                >
                    <Imatge
                        src='//statics.3cat.cat/recursos/marato/img/icn-recaptacions-htmltwig-Mira.marato.png'
                        alt=''
                        aria-hidden='true'
                        width={103}
                        height={37}
                    />
                    <span>{texts.recaptacions}</span>
                </Enllac>
                <Enllac
                    className={`${styles.boto} ${seccio === 'projectes' ? styles.selected : ''}`}
                    href={`/tv3/marato/${idioma}totes-maratons/mira-el-que-has-fet-possible/projectes/`}
                >
                    <Imatge
                        src='//statics.3cat.cat/recursos/marato/img/icn-recerca-htmltwig-Mira.marato.png'
                        alt=''
                        aria-hidden='true'
                        width={103}
                        height={37}
                    />
                    <span>{texts.projectes}</span>
                </Enllac>
                <Enllac
                    className={`${styles.boto} ${seccio === 'conferencies' ? styles.selected : ''}`}
                    href={`/tv3/marato/${idioma}totes-maratons/mira-el-que-has-fet-possible/conferencies/`}
                >
                    <Imatge
                        src='//statics.3cat.cat/recursos/marato/img/icn-conferencies-htmltwig-Mira.marato.png'
                        alt=''
                        aria-hidden='true'
                        width={103}
                        height={37}
                    />
                    <span>{texts.conferencies}</span>
                </Enllac>
                <Enllac
                    className={`${styles.boto} ${seccio === 'activitats' ? styles.selected : ''}`}
                    href={`/tv3/marato/${idioma}totes-maratons/mira-el-que-has-fet-possible/activitats/`}
                >
                    <Imatge
                        src='//statics.3cat.cat/recursos/marato/img/icn-activitats-populars-htmltwig-Mira.marato.png'
                        alt=''
                        aria-hidden='true'
                        width={103}
                        height={37}
                    />
                    <span>{texts.activitats}</span>
                </Enllac>
            </div>
        </div>
    );
};

export default MiraMarato;
